<template>
  <span :id="'footnote-container-'+index">
    <span
      :id="'footnote-'+index"
      tabindex="0"
      class="inline-footnote bg-dark-ben-franklin secondary"
      :class="{ 'active': (activeFootnoteId == index) }"
      @click="toggleFootnote"
      @keyup.enter="toggleFootnote"
    >
      <span
        v-if="activeFootnoteId == index"
        v-html="'x'"
      />
      <span
        v-if="activeFootnoteId != index"
        v-html="index"
      />
    </span>
    <main
      v-if="activeFootnoteId == index"
      :id="'footnote-copy-'+index"
      class="content footnote-container"
      :style="{ top: footnoteHeight }"
    >
      <div class="grid-container pbxl">
        <div class="columns grid-x">
          <div class="medium-5">
            <div
              class="footnote"
              tabindex="0"
            >
              <div v-html="index" />
              <div v-html="philaLink(copy)" />
            </div>
          </div>
        </div>
      </div>
    </main>
  </span>
</template>


<script>
export default {
  name: 'Footnote',
  props: {
    copy: {
      type: String,
      required: true,
    },
    index: {
      type: String,
      required: true,
    },
    activeFootnoteId: {
      type: String,
      default: null,
    },
  },
  data: function() {
    return {
      footnoteHeight: '0px',
    };
  },
  updated() {
    let vm = this;
    let offset = document.getElementById('footnote-container-'+vm.index).offsetTop;
    vm.footnoteHeight = offset+'px';
  },
  methods: {
    toggleFootnote () {
      let vm = this;
      if(vm.activeFootnoteId == vm.index) {
        this.$emit('activeFootnote', null);
      } else {
        this.$emit('activeFootnote', vm.index);
      }
    },
  },
};
</script>